<template>
  <div>
    <v-container>
      <h1 class="mb-2">{{$t('feeds.title')}}</h1>
      <custom-text msg="custom-text.feeds" class="mt-2 mb-1"></custom-text>
      <v-layout row>
        <div>
          <date-picker :date="now" :maxEnd="today" @updated="updatedDate"></date-picker>
        </div>
        <div class="pl-3">
          <v-btn color="primary" @click="refresh">{{$t('feeds.refresh')}}</v-btn>
        </div>
      </v-layout>
      <h3 class="mt-3">{{$t('feeds.sub_title')}}</h3>
    </v-container>
    <v-container grid-list-lg>
      <v-layout row wrap key="feed-wrapper">
        <transition-group name="feeds" tag="div" class="layout row wrap">
          <daily-feed v-for="feed in feedStatus" :key="id(feed)" :feed="feed" :feedDate="feedDate" :allowRun="allowRun"></daily-feed>
        </transition-group>
      </v-layout>
    </v-container>
    <v-container>
      <div :style="{ backgroundColor: noInteractionsColor}" class="no-data"
           v-if="feedStatus.length === 0">
        <div class="mt-2" :style="{color: getTextColor(noInteractionsColor)}">{{$t('feeds.no_feeds')}}</div>
      </div>
    </v-container>
  </div>
</template>

<script>
import DatePicker from '../date/DatePicker'
import DailyFeed from './DailyFeed'
import DailyFeedErrorList from './DailyFeedErrorList'
import Colors from '../../mixins/Colors'
import moment from 'moment-es6'
import { mapState, mapActions } from 'vuex'
import { GET_ENGAGEMENT_LAST_SUCCESSFUL, GET_FEEDS_FOR_DATE, RUN_FEED } from '../../store/action-types'
import CustomText from '../help/CustomText'

export default {
  name: 'daily-feeds-page',
  mixins: [Colors],
  data () {
    return {
      now: moment().format('YYYY-MM-DD'),
      today: moment().format('YYYY-MM-DD'),
      noInteractionsColor: this.$vuetify.theme.info
    }
  },
  computed: {
    ...mapState({
      feedStatus: state => state.feeds.feedStatus
    }),
    allowRun () {
      return this.today === this.now
    },
    feedDate () {
      return this.now
    }
  },
  methods: {
    ...mapActions({
      getFeeds: GET_FEEDS_FOR_DATE,
      runFeed: RUN_FEED,
      getEngagementLastSuccessful: GET_ENGAGEMENT_LAST_SUCCESSFUL
    }),
    updatedDate (newDate) {
      this.now = newDate
      this.getFeeds(newDate)
    },
    refresh () {
      this.getEngagementLastSuccessful()
      this.getFeeds(this.now)
    },
    doRunFeed (feed) {
      this.runFeed({processId: feed.processId, scheduleId: feed.scheduleId, date: this.today})
    },
    id (feed) {
      return `${feed.processId}-${feed.scheduleId}`
    }
  },
  mounted () {
    this.getFeeds(this.now)
  },
  components: {
    DatePicker, DailyFeed, DailyFeedErrorList, CustomText
  }
}
</script>

<style scoped>
.feeds-move {
  transition: transform .5s ease;
}
.col {
  padding: 6px 4px 6px 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/DailyFeedsPage.vue